module.exports = __webpack_public_path__ + "img/memberFacebook.ff6a2a5e.png";